import { render, staticRenderFns } from "./ModalAnexo.vue?vue&type=template&id=d2fef958"
import script from "./ModalAnexo.vue?vue&type=script&lang=js"
export * from "./ModalAnexo.vue?vue&type=script&lang=js"
import style0 from "./ModalAnexo.vue?vue&type=style&index=0&id=d2fef958&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports